import React from "react";
import service from 'axios';
import { siteApi, urunUrl, YuklenenLogoUrl } from '../Utils';
import { withTranslation } from "react-i18next";
import { formatPrice } from "../helpers/formatPrice";

class TemplateMenu2 extends React.Component {
    constructor(props) {
        super(props);
        this.companyId = props.company.Id;
        this.branchId = new URLSearchParams(props.location.search).get('u');

        this.cacheByLang = new Map();

        this.state = {
            Products: [],
            Company: {},
            Branch: {},
            ProductGroups: [],
            ProductsHtml: 0,
            CurrencyTourSymbol: "₺"
        };
        this.cevaplar = [];

        this.previousLanguage = null;
    }

    componentDidMount() {
        const currentLang = this.props.i18n.language;
        this.previousLanguage = currentLang;
        this.loadLanguageData(currentLang);

    }

    componentDidUpdate() {
        const currentLang = this.props.i18n.language;
        if (this.previousLanguage !== currentLang) {
            this.loadLanguageData(currentLang);
            this.previousLanguage = currentLang;
        }
    }

    loadLanguageData(language) {
        const cached = this.cacheByLang.get(language);
        if (cached) {
            this.setState({ ...cached }, () => {
                document.title = this.state.Company?.Adi || document.title;
            });
            return;
        }
        this.getData(language);
    }

    anketler(soru, soruNo) {
        if (soru !== null) {
            return (
                <div className="survey-question">
                    <h4 className="survey-question-title">{soru}</h4>
                    <div>
                        <span className="star-rating">
                            <input type="radio" name={"rating" + soruNo} value="1" onClick={(e) => {
                                if (this.cevaplar.filter(x => x.SoruNo === soruNo).length === 0) {
                                    this.cevaplar.push({
                                        SoruNo: soruNo,
                                        FirmaId: this.state.Company.Id,
                                        Puan: 1
                                    });
                                }
                                else {
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].SoruNo = soruNo;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].FirmaId = this.state.Company.Id;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].Puan = 1;
                                }
                            }} /><i></i>
                            <input type="radio" name={"rating" + soruNo} value="2" onClick={(e) => {
                                if (this.cevaplar.filter(x => x.SoruNo === soruNo).length === 0) {
                                    this.cevaplar.push({
                                        SoruNo: soruNo,
                                        FirmaId: this.state.Company.Id,
                                        Puan: 2
                                    });
                                }
                                else {
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].SoruNo = soruNo;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].FirmaId = this.state.Company.Id;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].Puan = 2;
                                }
                            }} /><i></i>
                            <input type="radio" name={"rating" + soruNo} value="3" onClick={(e) => {
                                if (this.cevaplar.filter(x => x.SoruNo === soruNo).length === 0) {
                                    this.cevaplar.push({
                                        SoruNo: soruNo,
                                        FirmaId: this.state.Company.Id,
                                        Puan: 3
                                    });
                                }
                                else {
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].SoruNo = soruNo;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].FirmaId = this.state.Company.Id;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].Puan = 3;
                                }
                            }} /><i></i>
                            <input type="radio" name={"rating" + soruNo} value="4" onClick={(e) => {
                                if (this.cevaplar.filter(x => x.SoruNo === soruNo).length === 0) {
                                    this.cevaplar.push({
                                        SoruNo: soruNo,
                                        FirmaId: this.state.Company.Id,
                                        Puan: 4
                                    });
                                }
                                else {
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].SoruNo = soruNo;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].FirmaId = this.state.Company.Id;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].Puan = 4;
                                }
                            }} /><i></i>
                            <input type="radio" name={"rating" + soruNo} value="5" onClick={(e) => {
                                if (this.cevaplar.filter(x => x.SoruNo === soruNo).length === 0) {
                                    this.cevaplar.push({
                                        SoruNo: soruNo,
                                        FirmaId: this.state.Company.Id,
                                        Puan: 5
                                    });
                                }
                                else {
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].SoruNo = soruNo;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].FirmaId = this.state.Company.Id;
                                    this.cevaplar.filter(x => x.SoruNo === soruNo)[0].Puan = 5;
                                }
                            }} /><i></i>
                        </span>
                    </div>
                </div>
            );
        } else {
            return (
                <React.Fragment>

                </React.Fragment>
            )
        }

    }

    getData(language) {
        service.get(siteApi + "webmusteri/getQrMenuInfo", {
            params: {
                companyId: this.companyId,
                branchId: this.branchId,
                language
            }
        })
            .then(res => {
                if (res.data.Success) {
                    if (!res.data?.Success) return;
                    const data = res.data.Data || {};
                    const nextState = {
                        Products: data.Products || [],
                        ProductGroups: data.ProductGroups || [],
                        Branch: data.Branch ?? {},
                        Company: data.Company ?? {},
                        BranchState: this.isBranchOpen(
                            data.Branch?.SubeBaslangicSaati,
                            data.Branch?.SubeBitisSaati
                        ),
                        CurrencyTourSymbol: window.ayarlar?.currencyTourSymbol?.find(x => x.code === (data.Company.DovizTuru || "TRY"))?.symbol ?? "₺"

                    };
                    this.cacheByLang.set(language, nextState);

                    this.setState(nextState, () => {
                        document.title = this.state.Company?.Adi || document.title;
                    });
                }
            });

    }

    getUrunListesi(id) {
        this.setState({
            ProductsHtml: id
        });
    }

    formatTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const hh = String(hours).padStart(2, '0');
        const mm = String(mins).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    isBranchOpen(startMinute, endMinute) {
        if (typeof startMinute !== "number" || typeof endMinute !== "number") return false;
        const now = new Date();
        const currentMinuteOfDay = now.getHours() * 60 + now.getMinutes();

        if (startMinute <= endMinute) {
            return currentMinuteOfDay >= startMinute && currentMinuteOfDay <= endMinute;
        } else {
            return false;
        }
    }

    render() {
        return (
            <React.Fragment>
                <header className="header">
                    <div className="banner banner-bordered" style={{ backgroundColor: this.state.Company.KurumsalRenk === null ? "white" : this.state.Company.KurumsalRenk }}>
                        <img className="banner-img" src={YuklenenLogoUrl + this.state.Company.QrMenuBanner} alt="banner" />
                        <div className="logo">
                            <a href={"/menu/tasarimbir/" + this.branchId}><img src={YuklenenLogoUrl + this.state.Company.Logo} alt={this.state.Company.Unvan} style={{ width: "228px", height: "164px" }} /></a>
                        </div>
                    </div>
                </header>
                <main className="main">
                    <div className="container">
                        <div class="top-section">
                            <h1 className="title">{this.state.Company.Adi} - {this.state.Branch.Adi}</h1>
                            <div class="dropdown">
                                <button class="btn btn-category btn-menu dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">{this.props.t("menu")}</button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    {
                                        this.state.ProductGroups.map((satir, index) =>
                                            <li>
                                                <button className="dropdown-item" type="button" onClick={() => {
                                                    this.getUrunListesi(satir.Id);
                                                }}>
                                                    {satir.Adi}
                                                </button>
                                            </li>
                                        )
                                    }


                                </ul>
                            </div>
                        </div>
                        <div className="products">
                            <div className="product-list">
                                {
                                    this.state.Products.filter(x => x.UrunGrubu.Id === (this.state.ProductsHtml === 0
                                        ? this.state.ProductGroups[0].Id
                                        : this.state.ProductsHtml)).map(satir =>
                                            <div className="product col-12 col-lg-6" key={satir.Id}>
                                                <div className="product-img"><a className="image-link"><img src={satir.Resim === null | satir.Resim === undefined ? YuklenenLogoUrl + this.state.Company.Logo : urunUrl + "kucukresimler/" + satir.Resim} alt="product" /></a></div>
                                                <div className="product-info">
                                                    <h3 className="product-name">{satir.Adi}</h3>
                                                    <div className="product-desc" dangerouslySetInnerHTML={{ __html: satir.Aciklama }}>
                                                    </div>
                                                    <div className="price">
                                                        <span className="new">
                                                            {this.props.t("price", { price: formatPrice(satir.MasaFiyati > 0 ? satir.MasaFiyati : satir.BirimFiyat, this.props.i18n.language), currency: this.state.CurrencyTourSymbol })}
                                                        </span>
                                                        {/* <span className="old">26 TL</span> */}
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                }
                            </div>
                        </div>
                    </div>
                    <div className="survey">
                        <button type="button" hidden={true} className="btn btn-survey" data-bs-toggle="modal" data-bs-target="#surveyModal">ANKETE KATILIN</button>
                    </div>
                </main>
                <footer className="footer">
                    <div className="container">
                        <div className="address-section">
                            <h3 className="footer-title">{this.state.Company.Adi} - {this.state.Branch.Adi}</h3>
                            <div className="address">{this.state.Branch.Adres}</div>
                            <div className="mail">{this.props.t("mail")} : <a href={"mailto:" + this.state.Branch.Email}>{this.state.Branch.Email}</a></div>
                            <div className="phone">{this.props.t("phone")} : <a href={"tel:" + this.state.Branch.Telefon}>{this.state.Branch.Telefon}</a></div>
                        </div>
                        <div className="working-days">
                            <div className="working-day">
                                <div className="day">{this.props.t("ourWorkingHours")}</div>
                                <div className="time">{this.formatTime(this.state.Branch.SubeBaslangicSaati)} - {this.formatTime(this.state.Branch.SubeBitisSaati)}</div>
                            </div>

                            {/* {this.state.CalismaSaatleri.map(satir => <div key={satir.id} className="working-day">
                                <div className="day">{satir.gun}</div>
                                <div className="time">{satir.saat}</div>
                            </div>)} */}
                        </div>
                        <div className="social-media">
                            <a
                                href={this.state.Company.InstagramAdresi === null ? "#" : this.state.Company.InstagramAdresi}
                                style={{ display: (this.state.Company.InstagramAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/instagram.svg" alt="instagram" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }} />
                            </a>
                            <a
                                href={this.state.Company.LinkedinAdresi === null ? "#" : this.state.Company.LinkedinAdresi}
                                style={{ display: (this.state.Company.LinkedinAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/linkedin.svg" alt="linkedin" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }} />
                            </a>
                            <a
                                href={this.state.Company.FacebookAdresi === null ? "#" : this.state.Company.FacebookAdresi}
                                style={{ display: (this.state.Company.FacebookAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/facebook.svg" alt="facebook" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }}
                                />
                            </a>
                            <a href={this.state.Company.TwitterAdresi === null ? "#" : this.state.Company.TwitterAdresi}
                                style={{ display: (this.state.Company.TwitterAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/twitter.svg" alt="twitter" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }} />
                            </a>
                            <a href={this.state.Company.VimeoAdresi === null ? "#" : this.state.Company.VimeoAdresi}
                                style={{ display: (this.state.Company.VimeoAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/vimeo.svg" alt="vimeo" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }} />
                            </a>
                            <a href={this.state.Company.YoutubeAdresi === null ? "#" : this.state.Company.YoutubeAdresi}
                                style={{ display: (this.state.Company.YoutubeAdresi === null ? "none" : "") }}
                            >
                                <img src="/assets/img/icons/youtube.svg" alt="youtube" style={{ height: "24px", width: "24px", backgroundColor: this.state.Company.KurumsalRenk }} />
                            </a>
                        </div>

                    </div>
                    <div className="footer-bottom">
                        <a href="https://www.yemekpos.com"><img style={{ width: "83px", height: "23px" }} src="/assets/img/YemekPos_LOGO.png" alt="YemekPos Logo" /></a>
                        <span>QR Menü © 2025 </span>
                    </div>
                </footer>

                <div className="modal survey-modal fade" id="surveyModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabel">Müşteri Anketi</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                {this.anketler(this.state.Company.AnketSoru1, 1)}
                                {this.anketler(this.state.Company.AnketSoru2, 2)}
                                {this.anketler(this.state.Company.AnketSoru3, 3)}
                                {this.anketler(this.state.Company.AnketSoru4, 4)}
                                {this.anketler(this.state.Company.AnketSoru5, 5)}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-send btn-survey" data-bs-target="#successModal" data-bs-toggle="modal" data-bs-dismiss="modal"

                                    onClick={() => {
                                        service.post(siteApi + "webmusteri/anketkaydet", this.cevaplar, null)
                                            .then((res) => {
                                                if (res.data.Success) {
                                                    alert("Anketimize katıldığınız için teşekkür ederiz");
                                                }
                                                else {
                                                    alert("Teknik bir hata oluştu, hata ayrıntısı:" + res.data.ErrorMessage);
                                                }
                                            });
                                    }}>GÖNDER</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation('translation', { keyPrefix: "templateMenu2" })(TemplateMenu2);